import { gql } from "@apollo/client";
import { accountErrorFragment } from "@dashboard/fragments/errors";

export const requestPasswordReset = gql`
  ${accountErrorFragment}
  mutation RequestPasswordReset($email: String!, $redirectUrl: String!) {
    requestPasswordReset(email: $email, redirectUrl: $redirectUrl) {
      errors {
        ...AccountError
      }
    }
  }
`;

export const resetPasswordWithOtp = gql`
  ${accountErrorFragment}
  mutation ResetPasswordWithOtp($email: String!, $otp: String!, $password: String!) {
    resetPasswordWithOtp(email: $email, otp: $otp, password: $password) {
      errors {
        ...AccountError
      }
    }
  }
`;

export const tokenCreate = gql`
  ${accountErrorFragment}
  mutation TokenCreate($email: String!, $password: String!) {
    tokenCreate(email: $email, password: $password) {
      token
      refreshToken
      csrfToken
      user {
        id
        email
        isStaff
        userPermissions {
          code
          name
        }
      }
      errors {
        ...AccountError
      }
    }
  }
`;

export const tokenRefresh = gql`
  ${accountErrorFragment}
  mutation TokenRefresh($refreshToken: String, $csrfToken: String) {
    tokenRefresh(refreshToken: $refreshToken, csrfToken: $csrfToken) {
      token
      errors {
        ...AccountError
      }
    }
  }
`;

export const tokenVerify = gql`
  ${accountErrorFragment}
  mutation TokenVerify($token: String!) {
    tokenVerify(token: $token) {
      isValid
      user {
        id
        email
      }
      errors {
        ...AccountError
      }
    }
  }
`;
